import { TCsvObject, WrongTypeError } from '@acme/core'
import { FormFile } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import Dialog from 'global/guides/Dialog'
import { useState } from 'react'
import ApiService from 'service/api/api.service'
import { toast } from 'sonner'

interface IProps {
    name: string
    api: InstanceType<typeof ApiService<any, any, any>>
    onDecodedCsv: (dados: string) => TCsvObject[]
}

export default function ModalImportar({ api, name, onDecodedCsv }: IProps) {
    const [paraImportar, setParaImportar] = useState<Array<any | null>>([])
    const [erro, setErro] = useState<string | null>(null)
    const { mutateAsync } = api.mutations.useCreate()

    const handleChange = (arquivo: File | null) => {
        setParaImportar([])
        setErro(null)
        if (!arquivo) return

        if (arquivo.type !== 'text/csv')
            return setErro(
                'Tipo de arquivo inválido, o formato suportado é CSV',
            )

        const reader = new FileReader()
        reader.readAsArrayBuffer(arquivo)
        reader.onload = e => {
            if (!e.target?.result) return
            try {
                const decoder = new TextDecoder('utf-8')
                const dados = decoder.decode(
                    new Uint8Array(e.target.result as ArrayBuffer),
                )
                setParaImportar(onDecodedCsv(dados))
            } catch (error) {
                if (error instanceof WrongTypeError) {
                    setErro(
                        `${error.message} na coluna ${error.header} da linha ${error.line}`,
                    )
                } else {
                    setErro(
                        'Erro ao ler o arquivo, verifique se as colunas estão corretas',
                    )
                }
            }
        }
    }

    return (
        <Dialog.Root
            onSubmit={async () => {
                return mutateAsync(paraImportar.filter(Boolean) as any, {
                    onError: erro => {
                        throw toast.error(erro.message.toString())
                    },
                    onSuccess: () => {
                        toast.success(`${name} importados com sucesso`)
                        api.invalidateQueries()
                    },
                })
            }}
        >
            <Dialog.Title>
                <span>Importar {name}</span>
                <IconeAjuda>
                    O arquivo deve ser um csv com os mesmos campos do arquivo
                    gerado na exportação.
                </IconeAjuda>
            </Dialog.Title>
            <Dialog.Content>
                <FormFile
                    name="arquivo"
                    notPreview
                    onChange={handleChange}
                    helperText={
                        !erro ? (
                            <span className="text-sm">
                                <strong>
                                    {paraImportar.filter(Boolean).length}
                                </strong>{' '}
                                {name?.toLowerCase()} para importar
                            </span>
                        ) : (
                            <span className="text-sm text-error">{erro}</span>
                        )
                    }
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Importar
                </Dialog.Actions.PrimaryButton>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
